export default {
  READINGROPE_PENDING: 'READINGROPE_PENDING',
  READINGROPE_COMPLETE: 'READINGROPE_COMPLETE',
  READINGROPE_ERROR: 'READINGROPE_ERROR',
}